export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8239.15fb9c97.jpg";